import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconVehiclesCaravanComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        className="lucide lucide-caravan"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2" fill="none" />
        <path d="M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2" fill="none" />
        <path d="M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9" fill="none" />
        <circle cx="8" cy="19" fill="none" r="2" />
      </svg>
    </SvgIcon>
  );
};

IconVehiclesCaravanComponent.displayName = 'IconVehiclesCaravan';

const IconVehiclesCaravan = React.memo(IconVehiclesCaravanComponent);

export default IconVehiclesCaravan;
